var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mt-3",attrs:{"cols":"12"}},[_c('accueil',{attrs:{"title":_vm.title}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }